import EditableSelect from './EditableSelect';

export default EditableSelect;
